import { FilterName } from 'src/plp/components/FilterName/FilterName';
import { PlpFiltersRange } from '../components/PlpFiltersRange/PlpFiltersRange';
import { Icon } from 'src/general/Icons/Icon';
import { FilterOption, PlpFilterBaseItemProps, PlpFiltersConditionalProps } from '../PlpFilters.type';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

type Props = Prettify<
  PlpFilterBaseItemProps & {
    options: {
      minOptions: FilterOption[];
      maxOptions: FilterOption[];
    };
    minValue: string | number;
    maxValue: string | number;
  } & PlpFiltersConditionalProps
>;

export const FilterYear = ({ options, minValue, maxValue, index, showNotificationBadge, ...props }: Props) => {
  const id = 'year';
  const header = <FilterName icon={<Icon name="calendar" />} label="Year" showNotificationBadge={showNotificationBadge} />;
  const content = (
    <PlpFiltersRange
      minOptions={options.minOptions}
      maxOptions={options.maxOptions}
      minValue={minValue}
      maxValue={maxValue}
      minPlaceholder="From"
      maxPlaceholder="To"
      {...props}
    />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
